




































import moment from 'moment-timezone';
import { Component, Vue } from 'vue-property-decorator';
import { IUser, User } from '@/models/User';
import LocalDataTable, {
  LocalDataField
} from '@/components/LocalDataTable.vue';
import constants from '@/utils/constants';
@Component
class UserTable extends LocalDataTable<User> {
  createItem(dataSnapshot: firebase.firestore.QueryDocumentSnapshot): User {
    const data = dataSnapshot.data();
    const user: IUser = {
      LoginID: dataSnapshot ? dataSnapshot.id : '',
      UID: data.UID,
      Type: data.Type,
      UserName: data.UserName,
      Email: data.Email,
      CreatedAt: data.CreatedAt,
      UpdatedAt: data.UpdatedAt,
      OutletCodes: data.OutletCodes
    };
    return new User(user);
  }
}

@Component({
  components: {
    UserTable
  }
})
export default class UserList extends Vue {
  public constants: any = constants;
  public fieldsSet: Array<LocalDataField> = [
    new LocalDataField({
      key: 'UID',
      label: 'Actions',
      class: 'text-center',
      sortable: false
    }),
    new LocalDataField({
      key: 'LoginID',
      label: 'User Login',
      class: 'text-center text-nowrap number-align'
    }),
    new LocalDataField({
      key: 'UserName',
      label: 'User Name'
    }),
    new LocalDataField({
      key: 'Email',
      label: 'Email'
    }),
    new LocalDataField({
      key: 'Type',
      label: 'User Type'
    }),
    new LocalDataField({
      key: 'CreatedAt',
      label: 'Created At'
    })
  ];

  // METHOD
  readAbleDateTime(timestamp) {
    return moment.unix(timestamp).format('dddd[,] DD MMMM YYYY');
  }

  newUser() {
    this.$router.push('/user/add');
  }

  editUser(id) {
    this.$router.push(`/user/${id}/edit`);
  }
}
